import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import Modal from 'components/ui/Modal';
import { CtaButton } from '../AfterSalesCtas.styles';
import { StyledButtonWrapper } from './ExchangeCtaOverride.styles.js';
import { ConfirmButton, CancelButton } from 'components/ui/Button';

const ExchangeCtaSNCBBookingWarning = ({ isExchangeDisabled, label, onClick }) => {
  const [showWarning, setShowWarning] = useState(false);

  const handleToggle = () => {
    setShowWarning(!showWarning);
  };

  const handleExchangeClick = () => onClick();

  return (
    <>
      <CtaButton
        type="button"
        data-cy="exchange-with-sncb-warning"
        data-id="exchange-with-sncb-warning"
        disabled={isExchangeDisabled}
        label={label}
        onClick={handleToggle}
      >
        {label}
      </CtaButton>

      {showWarning && (
        <Modal title={<FormattedMessage id="sncbStationBookingSelected" />} isOpen={showWarning} onClose={handleToggle}>
          <div>
            <FormattedMessage id="printWarning.SNCB" />
          </div>

          <StyledButtonWrapper>
            <ConfirmButton
              data-testid="confirm-exchange-with-sncb-warning"
              data-cy="confirm-exchange-with-sncb-warning"
              onClick={handleExchangeClick}
            >
              <FormattedMessage id="exchanges.confirm" />
            </ConfirmButton>

            <CancelButton
              type="button"
              data-cy="cancel-exchange-with-sncb-warning"
              data-testid="cancel-exchange-with-sncb-warning"
              onClick={handleToggle}
            >
              <FormattedMessage id="vouchers.cancel" />
            </CancelButton>
          </StyledButtonWrapper>
        </Modal>
      )}
    </>
  );
};

ExchangeCtaSNCBBookingWarning.propTypes = {
  isExchangeDisabled: PropTypes.bool,
  label: PropTypes.node,
  onClick: PropTypes.func,
  hasInsurance: PropTypes.bool
};

export default injectIntl(ExchangeCtaSNCBBookingWarning);
